<template>
  <div>
    <div @click="back" class="header border-bottom">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div v-for="item in list" :key="item.id">
      <div>
        <div class="shop">
          <i class="iconfont">&#xe624;</i>
          <h5>{{item.shop_name}}</h5>
        </div>
        <div class="goods-message" v-for="gitem in item.goodsList" :key="gitem.id">
          <div>
            <img :src="gitem.imgUrl ? url + gitem.imgUrl : defaultimg">
          </div>
          <div>
            <div>
              <p class="title">{{gitem.title}}</p>
            </div>
            <div class="order-price">
              <p>￥{{gitem.price}}</p>
              <p class="num">x{{gitem.num}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="order-detail">
        <p>付款方式<span>在线支付</span></p>
        <p>订单总价<span>￥{{item.totprice}}</span></p>
        <p class="final">实付款<span>￥{{item.fanalprice}}</span></p>
      </div>
      <div class="order-info">
        <h4>订单信息</h4>
        <p>订单编号：<span>{{item.ordernum}}</span></p>
        <p>订单金额：<span>￥{{item.orderprice}}</span></p>
        <p>订单日期：<span>{{item.date}}</span></p>
        <p>配送方式：<span>用户自提</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'OrderdetailCont',
  props: {
    list: Array
  },
  data () {
    return {
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 13px;}
.header .iconfont{ font-size: 25px;}
.header a{ text-decoration: none;}
.icon{ width: 55px; height: 55px; background-color: #6dc651; border-radius: 50%; margin-right: auto; margin-left: auto; margin-bottom: 5px;}
.message p{ text-align: center; font-size: 14px; color: #434343; margin-bottom: 10px;}
.message p span{ color: #a3a3a3;}
.message .message-title{ display: flex; justify-content: space-between; font-size: 14px; padding: 5px 0; margin-bottom: 0;}
.message{ background-color: #fff; padding: 10px 15px; border-bottom: 5px solid #f2f2f2; padding-bottom: 3px;}
.content{ background-color: #fff; border-top: 10px solid #eff3f6;}
.goods-message{ display: flex; justify-content: flex-start; font-size: 14px;}
.goods-message{ padding: 10px 15px; background-color: #f2f2f2; margin-bottom: 5px;}
.goods-message img{ margin-right: 11px; width: 80px; height: 80px;}
.spec{ color: #949494; margin-top: 5px;}
.num{ color: #434343; float: right;}
.order-price{ overflow: hidden; padding-top: 5px;}
.order-price p:first-child{ float: left; color: #ff0135;}
.shop{ padding: 10px 15px; padding-right: 0; display: flex; align-items: center;}
.shop h5{ font-size: 14px; color: #434343;}
.shop .iconfont{ margin-right: 5px;}
.title{ word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;}
.order-detail,.order-info{ padding: 10px 15px;}
.order-detail{ border-bottom: 10px solid #f5f5f5;}
.order-detail p{ display: flex; justify-content: space-between; font-size: 12px; line-height: 23px; color: #a9a8a8;}
.order-detail p.final{ color: #333; font-size: 14px;}
.order-detail p.final span{ color: #ff0135;}
.order-info p{ display: flex; justify-content: space-between; font-size: 12px; line-height: 23px; color: #a9a8a8;}
.order-info h4{ padding-bottom: 10px;}
</style>



// WEBPACK FOOTER //
// src/pages/order_detail/components/Content.vue